import { render, staticRenderFns } from "./skeleton-list.vue?vue&type=template&id=55c26477&scoped=true&"
import script from "./skeleton-list.vue?vue&type=script&lang=ts&"
export * from "./skeleton-list.vue?vue&type=script&lang=ts&"
import style0 from "./skeleton-list.vue?vue&type=style&index=0&id=55c26477&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c26477",
  null
  
)

export default component.exports